/* Monavida advertorial (USA): leesbalk bovenaan. */
(function () {
  var balk = document.querySelector('[data-adv-progress]');
  if (!balk) return;
  var gepland = false;
  function bijwerken() {
    gepland = false;
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var deel = max > 0 ? Math.min(h.scrollTop / max, 1) : 0;
    balk.style.transform = 'scaleX(' + deel + ')';
  }
  function plan() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(bijwerken);
  }
  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan, { passive: true });
  bijwerken();
})();
